import React from "react";
import propTypes from "prop-types";

const withTheme = mapFunction => Component => {
  class GetContext extends React.Component {
    render() {
      return <Component {...this.props} {...mapFunction(this.context.theme)} />;
    }
  }

  GetContext.contextTypes = { theme: propTypes.object };

  return GetContext;
};

export default withTheme;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/styles/withTheme.js